import type {
	SoundSettingValue,
	SoundsState,
} from "../redux/reducers/settings/sounds";

interface RingtoneCall {
	session?: {
		_is_confirmed?: boolean;
		direction?: string;
	} | null;
}

/**
 * Разговор идёт, если есть другой принятый звонок (в том числе на удержании)
 * или исходящий. Просто звонящий входящий разговором не считается.
 */
export function isConversationInProgress(calls: RingtoneCall[]): boolean {
	return calls.some(
		({ session }) =>
			Boolean(session?._is_confirmed) ||
			session?.direction === "outgoing",
	);
}

/** Настройка звука для нового входящего звонка. */
export function pickRingtone(
	otherCalls: RingtoneCall[],
	sounds: SoundsState,
): SoundSettingValue {
	return isConversationInProgress(otherCalls)
		? sounds.incomingCallDuringConversation
		: sounds.incomingCall;
}

/** Проценты настройки → значение HTMLMediaElement.volume (0–1). */
export function toAudioVolume(percent: number): number {
	const value = Number(percent);
	if (!Number.isFinite(value)) return 1;
	return Math.min(1, Math.max(0, value / 100));
}
